// src/components/Technologies.jsx
import React, { useEffect, useRef } from 'react';
import { useInView } from 'react-intersection-observer';
import '../../styles/technologies.css';

const technologies = [
  { name: 'Javascript',   imageSrc: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/javascript/javascript-original.svg", url: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript' },
  { name: 'Python',       imageSrc: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/python/python-original.svg",               url: 'https://www.python.org/' },
  { name: 'React',        imageSrc: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/react/react-original.svg",             url: 'https://reactjs.org/' },
  { name: 'Flask',        imageSrc: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/flask/flask-original.svg",             url: 'https://flask.palletsprojects.com/' },
  { name: 'HTML',         imageSrc: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/html5/html5-original.svg",             url: 'https://developer.mozilla.org/en-US/docs/Web/HTML' },
  { name: 'CSS',          imageSrc: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/css3/css3-original.svg",               url: 'https://developer.mozilla.org/en-US/docs/Web/CSS' },
  { name: 'Bootstrap',    imageSrc: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/bootstrap/bootstrap-original.svg",       url: 'https://getbootstrap.com/' },
  { name: 'JEST',         imageSrc: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/jest/jest-plain.svg",                url: 'https://jestjs.io/' },
  { name: 'NodeJs',       imageSrc: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nodejs/nodejs-original.svg",           url: 'https://nodejs.org/' },
  { name: 'PostgreSQL',   imageSrc: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/postgresql/postgresql-original.svg",     url: 'https://www.postgresql.org/' },
  { name: 'MySQL',        imageSrc: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/mysql/mysql-original.svg",             url: 'https://www.mysql.com/' },
  { name: 'Git',          imageSrc: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/git/git-original.svg",               url: 'https://git-scm.com/' }
];

// Duplicamos el array para loop infinito
const logos = [...technologies, ...technologies];

export default function Technologies() {
  const { ref: titleRef, inView: titleInView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  const containerRef = useRef(null);
  const frameIdRef = useRef(0);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    let paused = false;
    let remainder = 0;     
    const speed = 0.4;     

    const loop = () => {
      if (!paused) {
        remainder += speed;
        const move = Math.floor(remainder);
        if (move > 0) {
          el.scrollLeft += move;
          remainder -= move;
          if (el.scrollLeft >= el.scrollWidth / 2) {
            el.scrollLeft -= el.scrollWidth / 2;
          }
        }
      }
      frameIdRef.current = requestAnimationFrame(loop);
    };
    frameIdRef.current = requestAnimationFrame(loop);

    el.addEventListener('mouseenter', () => { paused = true; });
    el.addEventListener('mouseleave', () => { paused = false; });

    return () => {
      cancelAnimationFrame(frameIdRef.current);
      el.removeEventListener('mouseenter', () => { paused = true; });
      el.removeEventListener('mouseleave', () => { paused = false; });
    };
  }, []);

  return (
    <section id="tech">
      <h2
        ref={titleRef}
        className={`animate__animated ${titleInView ? 'animate__fadeInDown' : ''}`}
        style={{ '--animate-duration': '2s' }}
      >
        Technologies
      </h2>

      <div
        ref={containerRef}
        className={`scroll-container animate__animated ${titleInView ? 'animate__fadeInUp' : ''}`}
        style={{ '--animate-duration': '2s' }}
      >
        {logos.map((tech, i) => (
          <div
            key={i}
            className="logo-item"
            onClick={() => window.open(tech.url, '_blank')}
          >
            <img src={tech.imageSrc} alt={tech.name} className="logo" />
          </div>
        ))}
      </div>
    </section>
  );
}
